import { PowerCutIllustration } from '../../assets/illustrations';
import { Headings } from '../Headings';
import { Text } from '../Text';
import { ErrorPageProps } from './ErrorPage';

export const ErrorPageGeneric = ({ title, message }: ErrorPageProps) => {
  return (
    <>
      <Headings.H1>{title || 'Något gick fel'}</Headings.H1>
      <PowerCutIllustration width={[180, 180, 220]} />
      <Text size="large">
        {message || 'Vänligen kontakta Foras kundservice på telefon 08-787 40 10 för mer information.'}
      </Text>
    </>
  );
};
